import McQueryTable from './McQueryTable';

export default McQueryTable;
